<template>
  <el-container style="min-height: 100vh; ">
    <el-aside width="auto" style="box-shadow: 3px 0 5px rgb(0 21 41 /20%);height: 100vh" >
      <Aside />
    </el-aside>
    <el-container>
      <el-header style="z-index:999;height: 50px;box-shadow: 0 0 7px rgb(0 21 41 /20%);padding: 0" :style="{ backgroundColor: $store.state.headerColor }">
        <Header />
      </el-header>
      <el-main class="el-main">
        <Tabs type="card"
              v-model="$store.state.activeTabs"
              @on-click="changeTabs"
              @on-tab-remove="removeTabs"
              :before-remove="beforeRemove">
          <TabPane label="首页" name="/home" key="/home" style="background-color: white">
          </TabPane>
          <TabPane v-for="item in $store.state.pathUrlList" :key="item.path" :name="item.path" :label="item.name" closable >
          </TabPane>
        </Tabs>
        <div style="padding: 15px 0;background-color: white;">
          <router-view  />
        </div>
        <div class="custom-add-btn">
          <Dropdown  placement="bottom-end" @on-click="closeAllTabs">
            <Icon type="ios-arrow-down" style="font-weight: bold;"></Icon>
            <DropdownMenu slot="list">
              <DropdownItem><Icon type="ios-close-circle" style="margin-right: 10px" />全部关闭</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

import Aside from "@/components/Aside"
import Header from "@/components/Header";
import Vue from "vue";

export default {
  name: "KuangJia",
  props:{
  },
  data(){
    return{
      tabUrl:''
    }
  },
  components:{
    Header,
    Aside
  },
  methods:{
    clearCache(routePath) {
      const cachedComponents = Object.keys(Vue.options.components)
          .filter(name => name.startsWith('RouterView'))
          .map(name => Vue.options.components[name]);

      cachedComponents.forEach(component => {
        if (component.options.$route.path === routePath) {
          component.options._Ctor = {};
        }
      });
    },
    changeTabs(val){
      if (this.$route.path !== val) {
        this.$router.push(val)
      }
    },
    beforeRemove(val){
      console.log('beforeRemove',val)
      console.log('beforeRemoveActiveTabs',this.$store.state.activeTabs)
      this.tabUrl = this.$store.state.activeTabs
    },
    removeTabs(val){
      if (val !== '/home'){
        console.log('$router',this.$router)
        console.log('$route',this.$route)
        // this.clearCache(val)
        setTimeout(()=>{
          console.log('$router1',this.$router)
          let index = this.$store.state.pathUrlList.findIndex(item => item.path === val)
          //先判断删除页是否显示
          if(val === this.tabUrl && val !== '/home'){
            //是
            //第一种情况：删除的是最后一个tab
            console.log('length',this.$store.state.pathUrlList.length)
            if (index === this.$store.state.pathUrlList.length - 1){
              // 使用 filter 方法过滤出不匹配的对象，生成新的列表
              this.$store.state.pathUrlList = this.$store.state.pathUrlList.filter(obj => obj.path !== val);
              if (index > 0){
                this.$router.push(this.$store.state.pathUrlList[index-1].path)
              }else {
                this.$router.push('/home')
              }
            }
            //第二种情况：不是最后一个,
            else{
              this.$store.state.pathUrlList = this.$store.state.pathUrlList.filter(obj => obj.path !== val);
              this.$router.push(this.$store.state.pathUrlList[index].path)
            }
          } else {
            //不是
            this.$store.state.pathUrlList = this.$store.state.pathUrlList.filter(obj => obj.path !== val);
          }
        },500)
      }else {
        return 0
      }
    },
    closeAllTabs(){
      this.$store.state.pathUrlList = []
      if (this.$store.state.activeTabs !== '/home'){
        this.$router.push('/home')
      }
    }
  }
  ,
}
</script>

<style scoped>
.el-main{
  padding:10px 10px;
  background-color: #f8f8f9;
  height: 100%;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.05) inset;
}
>>>.ivu-tabs-bar {
  border-bottom: none !important;
  margin-bottom: 0 !important;
  position: relative;
  padding-right: 40px;
}
.custom-close-btn,
.custom-add-btn {
  position: absolute;
  top: 50px;
  height: 28px;
  width: 28px;
  right: 10px;
  margin-top: 8px;
  background-color: white;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
}


.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab{
  border-radius: 0;
  background: #fff;
}
.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active{
  border-top: 1px solid #3399ff;
}
.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active:before{
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background: #3399ff;
  position: absolute;
  top: 0;
  left: 0;
}

</style>
